/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PaymentChannel {
    SIGNED_IN_PORTAL = 'SignedInPortal',
    GUEST_PAY = 'GuestPay',
    INSTAPAY = 'Instapay',
    IVR = 'IVR',
    TERMINAL = 'Terminal',
    ONE_TIME_PAYMENT = 'OneTimePayment',
    RECURRING_PAYMENT = 'RecurringPayment',
    CASH_COLLECTIONS = 'CashCollections',
    KIOSK = 'Kiosk',
    U_RECEIVABLES = 'uReceivables',
    U_SCAN = 'uScan',
    LOCK_BOX = 'Lock_Box',
    THIRD_PARTY_CC = 'ThirdPartyCC',
    THIRD_PARTY_ACH = 'ThirdPartyACH',
    RETURNED_PAYMENT = 'ReturnedPayment',
    MULTI_OWNER = 'MultiOwner',
    BANK_LOCK_BOX = 'BankLockBox',
}